import { cn } from "@/lib/utils";

function Skeleton({
    className,
    ...props
}: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={cn(
                "rounded-default bg-neutral-default animate-pulse",
                className,
            )}
            {...props}
        />
    );
}

export { Skeleton };
